import { isNilOrEmpty } from './objectUtils';
import { CustomSubscription } from './types';

// Dashboard V2 invalidation bus contract (docs/specs/00-architecture.md §4): the message NEVER
// carries a business payload — receivers invalidate the queries of the listed domains and let
// TanStack Query refetch. The domain and event taxonomies are closed lists, extended via PR.
export const MEMBERS_INVALIDATION_DOMAIN = 'members';

export const PAYMENTS_INVALIDATION_DOMAIN = 'payments';

export const RENT_TRACKING_INVALIDATION_DOMAIN = 'rent-tracking';

export const INVALIDATION_DOMAINS = [
  MEMBERS_INVALIDATION_DOMAIN,
  PAYMENTS_INVALIDATION_DOMAIN,
  RENT_TRACKING_INVALIDATION_DOMAIN,
] as const;

export const MAX_INVALIDATION_ENTITY_IDS = 200;

export type InvalidationDomain = (typeof INVALIDATION_DOMAINS)[number];

export enum InvalidationEventType {
  MEMBER_ROLE_CHANGED = 'member.role_changed',
  MEMBER_STATUS_CHANGED = 'member.status_changed',
  PAYMENTS_CHANGED = 'payments.changed',
  RENT_LEASE_YEAR_CHANGED = 'rent.lease_year_changed',
}

export interface InvalidationMessage {
  wsId: string;
  domains: InvalidationDomain[];
  entityIds?: string[];
  eventType: InvalidationEventType;
}

export const getCustomSubscriptionValueForInvalidation = (message: InvalidationMessage): string =>
  JSON.stringify(message);

// The REFETCH channel also carries legacy `{table}` payloads — those (and any malformed value) parse to null.
export const parseInvalidationMessage = (customSubscription: CustomSubscription): InvalidationMessage | null => {
  try {
    const parsed = JSON.parse(customSubscription.value) as Partial<InvalidationMessage>;
    if (isNilOrEmpty(parsed.wsId) || !Array.isArray(parsed.domains) || isNilOrEmpty(parsed.eventType)) {
      return null;
    }
    return parsed as InvalidationMessage;
  } catch {
    return null;
  }
};
